module.exports = "/packs/media/modules/welcome/welcome/faq/assets/banner-d0af10416dfb8edf3001944d2c77f114.png";